// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"a027e7e7","596":"643fe4c1"}[chunkId] + ".chunk.js";
};